export const OPTHINES = {
  voteName: '2020project/2020earsps',
  mustSearch: 'Button',
  buttonBg: '#3ab5bb',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: 'rgb(26 91 94)',
    inactiveBgColor: '#3ab5bb',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/20200731WSSL/First',
    },
    {
      tabName: '我要投稿',
      tabPath: '/20200731WSSL/User',
    },
  ],
  Grades: [
    '一年级',
    '二年级',
    '三年级',
    '四年级',
    '五年级',
    '六年级',
    '初一',
    '初二',
    '初三',
    '高一',
    '高二',
    '高三',
    '大一',
    '大二',
    '大三',
    '大四',
  ],
};
